import { Pipe, PipeTransform } from "@angular/core";
import { CustomerAddress } from "../interfaces/interfaces";

@Pipe({
    name: 'address'
})
export class AddressPipe implements PipeTransform {
    transform(customerAddress: CustomerAddress): string {
        const addressParts: string[] = [customerAddress.country, customerAddress.postcode, customerAddress.city];
        if (customerAddress.addressType === 'FOREIGN' || customerAddress.addressType === 'OTHER') {
            if (customerAddress.address) { addressParts.push(customerAddress.address); }
        } else {
            if (customerAddress.publicPlaceName) { addressParts.push(customerAddress.publicPlaceName); }
            if (customerAddress.publicPlaceType) { addressParts.push(customerAddress.publicPlaceType); }
            if (customerAddress.houseNumber) { addressParts.push(customerAddress.houseNumber); }
            if (customerAddress.level) { addressParts.push(customerAddress.level); }
            if (customerAddress.door) { addressParts.push(customerAddress.door); }
            if (customerAddress.parcelNumber) { addressParts.push('(Helyrajzi szám: ' + customerAddress.parcelNumber + ')') }
        }
        return addressParts.join(' ');
    }
}